<template>
  <div class="spotlight-image" :style="{ backgroundImage: `url(${file.url})`}">
    <img class="spotlight-image__img" src="file.url" :alt="file.name" />
  </div>
</template>
<script>
export default {
  props: {
    file: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="stylus">
.spotlight-image
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-position: center center;
  background-size: cover;
  .spotlight-image__img
    visibility: hidden;
    max-width: 100%;
    height: auto;
</style>
